import React, { useState, useEffect, useRef } from "react";
import Logo from "./ImgHeader/logo.svg";
import iconmenu from "./ImgHeader/iconmenu.svg";
import iconmenuopen from "./ImgHeader/iconmenuopen.svg";
import { Link, useLocation } from "react-router-dom";
import fundo from "./ImgHeader/img_fundo.svg";
import fundoHome from "./ImgHeader/IconHome.svg";
import languageData from "./traducao.json";
import flagPT from "./ImgHeader/brasil.png"; 
import flagEN from "./ImgHeader/espanha.png"; 
import flagES from "./ImgHeader/estados-unidos.png"; 

function Header() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false); 
    const [windowWidth, setWindowWidth] = useState(window.innerWidth); 
    const [isDropdownOpen, setDropdownOpen] = useState(null); 
    const [currentLanguage, setCurrentLanguage] = useState('pt'); 

    const isHomePage = location.pathname === "/home";
    const menuRef = useRef(null); 
    const containerRef = useRef(null); 

    const toggleMenu = () => setMenuOpen(!menuOpen); 

    useEffect(() => {
        const savedLanguage = localStorage.getItem("siteLanguage");
        const browserLanguage = navigator.language.split('-')[0];
        const supportedLanguages = ['pt', 'en', 'es'];
    
        if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
            setCurrentLanguage(savedLanguage);
        } else if (supportedLanguages.includes(browserLanguage)) {
            setCurrentLanguage(browserLanguage);
        } else {
            setCurrentLanguage('pt');
        }
    
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if (window.innerWidth > 1500) {
                setMenuOpen(false);
            }
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !containerRef.current.contains(event.target)) {
                setDropdownOpen(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside); 
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleDropdownClick = (section) => {
    setDropdownOpen(prevState => prevState === section ? null : section);
    };

    const handleMouseEnter = (section) => {
        setDropdownOpen(section);
    };

    const handleMouseLeave = () => {
        setDropdownOpen(null);
    };

    const translations = languageData[currentLanguage];

    const handleLanguageChange = (e) => {
        const selectedLang = e.target.value;
        setCurrentLanguage(selectedLang);
        localStorage.setItem("siteLanguage", selectedLang);
        window.location.reload(); 
    };

    return (
        <div>
            <div 
                ref={containerRef}
                className="z-10 flex justify-between items-center mt-[2%] mb-[10%] mx-[3%] max-[1500px]:mx-[7%]"
            >
                {/* Logo */}
                <div>
                    <Link to="/home">
                        <img src={Logo} className="w-[260px] m-0" alt="Logo" />
                    </Link>
                </div>

                {/* Menu Mobile Button */}
                <button 
                    className="hidden max-[1500px]:block bg-transparent border-none text-white mr-[50px] max-[768px]:mr-0"
                    onClick={toggleMenu}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                    </svg>
                </button>

                {/* Navigation */}
                <div 
                ref={menuRef} 
                className={`
                    font-bold text-[13px] flex gap-8 items-center
                    max-[1500px]:fixed max-[1500px]:top-0 max-[1500px]:right-0
                    max-[1500px]:h-screen max-[1500px]:w-[350px] max-[768px]:w-[80vw]
                    max-[1500px]:flex-col max-[1500px]:bg-gradient-to-r 
                    max-[1500px]:from-[#b65ef5] max-[1500px]:to-[#f879b9]
                    max-[1500px]:p-6 max-[1500px]:z-50
                    max-[1500px]:transition-transform max-[1500px]:duration-300
                    ${menuOpen 
                    ? 'max-[1500px]:translate-x-0' 
                    : 'max-[1500px]:translate-x-full'
                    }
                `}
                >


                    {/* Close Button */}
                    <button 
                        className="hidden max-[1500px]:block bg-transparent border-none text-white max-[768px]:mt-[5%]"
                        onClick={toggleMenu}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </button>

                    {/* Home Link */}
                    <Link 
                        className={`
                            py-2 px-[10px] text-[1.3rem] no-underline
                            ${location.pathname === "/home" 
                                ? 'text-[#C367CC] font-bold bg-white py-[6px] px-2 rounded-[15px] hover:text-[#C367CC]' 
                                : 'text-white'}
                            hover:text-[#C367CC] hover:bg-white hover:shadow-[5px_5px_10px_rgba(0,0,0,0.3)] hover:rounded-[15px] 
                        `}
                        to="/home"
                    >
                        {translations.home}
                    </Link>

                    {/* Dropdown "Sobre Nós" */}
                    <div 
                        className="relative inline-block group"
                        onMouseEnter={() => handleMouseEnter("sobreNos")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <div className="group-hover:invisible">
                            <Link 
                                className={`
                                    py-2 px-[10px] text-[1.3rem] no-underline
                                    ${["/membros", "/contatos", "/proposito"].includes(location.pathname) ? 
                                        'text-[#C367CC] font-bold bg-white py-[6px] px-2 rounded-[15px] hover:text-[#C367CC]' : 
                                        'text-white'}
                                    hover:text-[#C367CC] hover:bg-white hover:shadow-[5px_5px_10px_rgba(0,0,0,0.3)] hover:rounded-[15px] 
                                `}
                                to="#"
                            >
                                {translations.sobreNos}
                                <img 
                                    src={["/membros", "/contatos", "/proposito"].includes(location.pathname) ? iconmenuopen : iconmenu} 
                                    alt="Ícone de menu"
                                    className="inline ml-1"
                                />
                            </Link>
                        </div>

                        {isDropdownOpen === "sobreNos" && (
                            <div className="
                                flex flex-col absolute -mt-[21%] -ml-[8%] rounded-[15px] pl-[5px] pb-[10px] 
                                text-left shadow-[5px_5px_10px_rgba(0,0,0,0.3)] bg-white w-[150px] z-10
                                max-[1500px]:ml-0 max-[1500px]:relative max-[1500px]:w-[190px] max-[1500px]:-mt-[22%] max-[1500px]:-mb-[10%]
                            ">
                                <Link 
                                    to="#" 
                                    className="text-[1.3rem] text-[#C367CC] p-[10px] no-underline inline-block"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    {translations.sobreNos}
                                    <img 
                                        className="inline ml-1 rotate-180" 
                                        src={iconmenuopen} 
                                        alt='iconmenuopen'
                                    />
                                </Link>
                                <Link 
                                    to="/proposito" 
                                    className={`
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                        ${location.pathname === "/proposito" ? 'text-[#C367CC]' : ''}
                                    `}
                                >
                                    {translations.nossoProposito}
                                </Link>
                                <Link 
                                    to="/membros" 
                                    className={`
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                        ${location.pathname === "/membros" ? 'text-[#C367CC]' : ''}
                                    `}
                                >
                                    {translations.membros}
                                </Link>
                                <Link 
                                    to="/contatos" 
                                    className={`
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                        ${location.pathname === "/contatos" ? 'text-[#C367CC]' : ''}
                                    `}
                                >
                                    {translations.contatos}
                                </Link>
                            </div>
                        )}
                    </div>

                    {/* Notícias Link */}
                    <Link 
                        className={`
                            py-2 px-[10px] text-[1.3rem] no-underline
                            ${location.pathname === "/noticias" ? 
                                'text-[#C367CC] font-bold bg-white py-[6px] px-2 rounded-[15px] hover:text-[#C367CC]' : 
                                'text-white'}
                            hover:text-[#C367CC] hover:bg-white hover:shadow-[5px_5px_10px_rgba(0,0,0,0.3)] hover:rounded-[15px] 
                        `}
                        to="/noticias"
                    >
                        {translations.noticias}
                    </Link>

                    {/* Dropdown "Publicações" */}
                    <div 
                        className="relative inline-block group"
                    onMouseEnter={() => handleMouseEnter("publicacoes")}
                    onMouseLeave={handleMouseLeave}
                    >
                        <div className="group-hover:invisible">
                        <Link 
                                className={`
                                    py-2 px-[10px] text-[1.3rem] no-underline
                                    ${["/artigos", "/ebooks"].includes(location.pathname) ? 
                                        'text-[#C367CC] font-bold bg-white py-[6px] px-2 rounded-[15px] hover:text-[#C367CC]' : 
                                        'text-white'}
                                    hover:text-[#C367CC] hover:bg-white hover:shadow-[5px_5px_10px_rgba(0,0,0,0.3)] hover:rounded-[15px] 
                                `}
                        to="#"
                        >
                                {translations.publicacoes}
                                <img 
                            src={["/artigos", "/ebooks"].includes(location.pathname) ? iconmenuopen : iconmenu} 
                            alt="Ícone de menu"
                                    className="inline ml-1"
                        />
                        </Link>
                    </div>

                    {isDropdownOpen === "publicacoes" && (
                            <div className="
                                flex flex-col absolute -mt-[21%] -ml-[8%] rounded-[15px] pl-[5px] pb-[10px] 
                                text-left shadow-[5px_5px_10px_rgba(0,0,0,0.3)] bg-white w-[180px] z-10
                                max-[1500px]:ml-0 max-[1500px]:relative max-[1500px]:w-[190px] max-[1500px]:-mt-[20%] max-[1500px]:-mb-[10%]
                            ">
                                <Link 
                                    to="#" 
                                    className="text-[1.3rem] text-[#C367CC] p-[10px] no-underline inline-block"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    {translations.publicacoes}
                                    <img 
                                        className="inline ml-1 rotate-180" 
                                        src={iconmenuopen} 
                                        alt="iconsinal"
                                    />
                                </Link>
                                <Link 
                                    to="/artigos"
                                    className="
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                    "
                                >
                                    {translations.artigos}
                                </Link>
                                <Link 
                                    to="/anaisconpeex"
                                    className="
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                    "
                                >
                                    {translations.anaisconpeex}
                                </Link>
                                <Link 
                                    to="/anaissbpqo"
                                    className="
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                    "
                                >
                                    {translations.anaissbpqo}
                                </Link>
                                <Link 
                                    to="/ebooks"
                                    className="
                                        text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block relative
                                        transition-colors duration-300 ease-in-out
                                        hover:text-[#C367CC]
                                        after:content-[''] after:absolute after:bottom-[5px] after:left-0 after:w-0 
                                        after:h-1 after:bg-gradient-to-r after:from-[#6A0DAD] after:to-[#FF66B2] 
                                        after:transition-all after:duration-300 after:ease-in-out after:rounded-[2px]
                                        hover:after:w-full
                                    "
                                >
                                    {translations.ebooks}
                                </Link>
                                <Link 
                                    className="text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block" 
                                    to=""
                                >
                                    {translations.dissertacoesETeses}
                                </Link>
                                <Link 
                                    className="text-[1.2rem] p-[10px] no-underline text-gray-500 inline-block" 
                                    to=""
                                >
                                    {translations.producaoTecnica}
                        </Link>
                        </div>
                    )}
                    </div>

                    {/* Capacitações Link */}
                    <Link 
                        className={`
                            py-2 px-[10px] text-[1.3rem] no-underline
                            ${location.pathname === "/capacitacoes" ? 
                                'text-[#C367CC] font-bold bg-white py-[6px] px-2 rounded-[15px] hover:text-[#C367CC]' : 
                                'text-white'}
                            hover:text-[#C367CC] hover:bg-white hover:shadow-[5px_5px_10px_rgba(0,0,0,0.3)] hover:rounded-[15px] 
                        `}
                        to="/capacitacoes"
                    >
                        {translations.capacitacao}
                    </Link>

                    {/* Área Restrita Link */}
                    <Link 
                        className="
                            rounded-[15px] py-2 px-[10px] text-[1.3rem] no-underline 
                            bg-[#bb47df] shadow-[5px_5px_10px_rgba(0,0,0,0.3)] text-white 
                            inline-block text-center transition-all duration-300 ease-in-out
                            hover:bg-[#a23cc9] hover:shadow-[8px_8px_15px_rgba(0,0,0,0.4)] hover:scale-105
                        "
                        to=""
                    >
                        {translations.arearestrita}
                    </Link>

                    {/* Language Selector */}
                    <div className="flex gap-[10px] justify-center items-center">
                        <div
                            className={`
                                cursor-pointer p-2 rounded-full transition-transform duration-200 ease-in-out
                                hover:scale-110
                                ${currentLanguage === 'pt' ? 'border-4 border-white border-solid' : ''}
                            `}
                            onClick={() => handleLanguageChange({ target: { value: 'pt' } })}
                        >
                            <img src={flagPT} alt="Português" className="w-[30px] h-auto" />
                        </div>
                        <div
                            className={`
                                cursor-pointer p-2 rounded-full transition-transform duration-200 ease-in-out
                                hover:scale-110
                                ${currentLanguage === 'en' ? 'border-4 border-white border-solid' : ''}
                            `}
                            onClick={() => handleLanguageChange({ target: { value: 'en' } })}
                        >
                            <img src={flagES} alt="English" className="w-[30px] h-auto" />
                        </div>
                        <div
                            className={`
                                cursor-pointer p-2 rounded-full transition-transform duration-200 ease-in-out
                                hover:scale-110
                                ${currentLanguage === 'es' ? 'border-4 border-white border-solid' : ''}
                            `}
                            onClick={() => handleLanguageChange({ target: { value: 'es' } })}
                        >
                            <img src={flagEN} alt="Español" className="w-[30px] h-auto" />
                        </div>
                    </div>
                </div>

                {/* Background Image */}
                <img 
                    src={isHomePage ? fundoHome : fundo} 
                    className={`
                        absolute top-0 left-0 w-full object-cover object-center -z-[5]
                        max-[1500px]:h-[28vh] max-[1500px]:min-h-[250px]
                        ${isHomePage ? 'max-[1500px]:min-h-[710px] max-[1500px]:h-[80vh] max-[1500px]:object-top' : ''}
                    `}
                    alt="fundo" 
                />
            </div>
        </div>
    );
}

export default Header;
